import React, { useState, useEffect } from 'react';
import './common.css';
import { NavLink } from 'react-router-dom';
import logo from '../../assets/images/logo.svg';
import logoinner from '../../assets/images/logo-inner.svg';
import BestOfferModal from './BestOfferModal';
import {
  BUSINESS_LOAN_PAGE_ROUTE,
  CREDIT_REPORT_APPLY_ROUTE,
  PERSONAL_LOAN_PAGE_ROUTE,
} from '../../data/routes-constants';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isModalOpen, setIsModalopen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleNavbar = () => {
    setIsCollapsed(!isCollapsed);
  };

  useEffect(() => {
    function handleScroll() {
      setIsScrolled(window.scrollY > 0);
    }

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div
      className={`headermain  ${
        isScrolled || isCollapsed ? 'headermain_scroll' : ''
      }`}>
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="container">
          <NavLink className="navbar-brand" to="/" onClick={scrollToTop}>
            <img src={logo} alt="Logo" />
            <img src={logoinner} alt="Logo" className="logo_onscroll" />
          </NavLink>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={toggleNavbar}>
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mr-auto">
              <li className="nav-item active">
                <NavLink to="/" className="nav-link" onClick={scrollToTop}>
                  Home <span className="sr-only">(current)</span>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to={BUSINESS_LOAN_PAGE_ROUTE}
                  className="nav-link"
                  onClick={scrollToTop}>
                  Business Loan
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to={PERSONAL_LOAN_PAGE_ROUTE}
                  className="nav-link"
                  onClick={scrollToTop}>
                  Personal Loan
                </NavLink>
              </li>
            </ul>

            <ul className="navbar-nav ml-auto tw-items-center sm:tw-items-start">
              <li className="nav-item tw-mr-[28px]">
                <NavLink
                  to={CREDIT_REPORT_APPLY_ROUTE + '?loanType=CS'}
                  className="nav-link"
                  onClick={scrollToTop}>
                  Sign in
                </NavLink>
              </li>
              <li
                className={`nav-item nav_check tw-cursor-pointer tw-rounded-[4px] tw-leading-[28px] ${
                  isScrolled ? 'tw-bg-[#F05913] tw-border-[#ffffff]' : ''
                }`}>
                <a
                  // to="#"
                  className={`nav-link ${
                    isScrolled
                      ? 'tw-text-[#ffffff] tw-border-[#ffffff] tw-rounded-[4px]'
                      : ''
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    setIsModalopen(true);
                  }}>
                  Get Best Offers
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      {isModalOpen && (
        <BestOfferModal
          isModalOpen={isModalOpen}
          setIsModalopen={setIsModalopen}
        />
      )}
    </div>
  );
};

export default Header;
